module.exports = __webpack_public_path__ + "img/金樱子.b5f5beef.jpg";